import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '@myenv/environment';

@Component({
    selector: 'app-reports-redesign',
    templateUrl: './redesign.component.html',
    styleUrls: ['./redesign.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RedesignComponent implements OnInit {

  readonly assetBase = 'assets/graphic-reports/redesign';

  activeReport:
    | 'product-code-distribution'
    | 'operational-insights'
    | 'protocol-report'
    | 'sim-usage-report' = 'operational-insights';

  constructor(
    private title: Title
  ) { }

  ngOnInit() {
    this.title.setTitle('Redesign' + environment.title_text);
  }

  asset(path: string): string {
    return `${this.assetBase}/${path}`;
  }

  selectReport(
    report:
      | 'product-code-distribution'
      | 'operational-insights'
      | 'protocol-report'
      | 'sim-usage-report'
  ): void {
    this.activeReport = report;
  }

}
